export const angleIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 1v5 2.283 2.006V19h8.809 2.008H13h6l-2-2h-5.234A10 10 0 0 0 3 8.313V3zm2 9.328c3.464.501 6.211 3.22 6.75 6.672H3z"/></svg>`,
  name: 'angle',
};
